import yup from 'src/libraries/validator.library';

export const RiskAssessmentKeySchema = yup
  .object()
  .shape({
    fieldKey: yup.number().required(),
    fieldName: yup.string().required(),
    section: yup.string().required(),
    fieldValue: yup.number().required(),
  })
  .defined();

export const RiskAssessmentPayloadSchema = yup
  .object()
  .shape({
    riskAssessmentKey: yup.array().of(RiskAssessmentKeySchema),
  })
  .defined();

export type IRiskAssessmentKeySchema = yup.InferType<
  typeof RiskAssessmentKeySchema
>;
export type IRiskAssessmentPayloadSchema = yup.InferType<
  typeof RiskAssessmentPayloadSchema
>;
